/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SendInsightShareEmailInput = {
    insightShareId?: string | null | undefined;
    emails: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type sendInsightShareEmailMutationVariables = {
    input: SendInsightShareEmailInput;
};
export type sendInsightShareEmailMutationResponse = {
    readonly sendInsightShareEmail: {
        readonly viewer: {
            readonly id: string;
        } | null;
    } | null;
};
export type sendInsightShareEmailMutation = {
    readonly response: sendInsightShareEmailMutationResponse;
    readonly variables: sendInsightShareEmailMutationVariables;
};



/*
mutation sendInsightShareEmailMutation(
  $input: SendInsightShareEmailInput!
) {
  sendInsightShareEmail(input: $input) {
    viewer {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendInsightShareEmailInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendInsightShareEmailPayload",
    "kind": "LinkedField",
    "name": "sendInsightShareEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendInsightShareEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendInsightShareEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sendInsightShareEmailMutation",
    "operationKind": "mutation",
    "text": "mutation sendInsightShareEmailMutation(\n  $input: SendInsightShareEmailInput!\n) {\n  sendInsightShareEmail(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '81fbc49baf50bab486fb23f8db97c57e';
export default node;
